import {observer} from 'mobx-react-lite'
import React from 'react'
import {IconButton} from '@components/common/base/buttons'
import {useMultiActionsWithTasksStore} from '../multi-actions-with-tasks-store'
import {ApplyCustomStickerPopup} from '../popups/apply-custom-sticker-popup'
import {DeleteTasksPopup} from '../popups/delete-tasks-popup'
import {NoRightsToSomeTasksPopup} from '../popups/no-rights-to-some-tasks-popup'
import {More} from './more'
import {Move} from './move'

export type MultiActionVisibleItem =
  | 'check'
  | 'uncheck'
  | 'archive'
  | 'unarchive'
  | 'move'
  | 'delete'
  | 'more'

type ActionsProps = {
  visibleItems?: MultiActionVisibleItem[]
}

export const Actions = observer(({visibleItems}: ActionsProps) => {
  const [state, store] = useMultiActionsWithTasksStore()

  const isVisible = (name: MultiActionVisibleItem) =>
    !visibleItems || visibleItems?.includes(name)

  return (
    <>
      <NoRightsToSomeTasksPopup />
      <DeleteTasksPopup />
      <ApplyCustomStickerPopup />
      {isVisible('check') && state.uncheckedTasks.length > 0 && (
        <IconButton
          icon="IconCircleCheck"
          color="secondary"
          onClick={store.checkAll}
          size="small"
          wrapperSize="big"
          className="-m-4"
        />
      )}
      {isVisible('uncheck') && state.checkedTasks.length > 0 && (
        <IconButton
          icon="IconCircleCheckFilled"
          color="secondary"
          onClick={store.uncheckAll}
          size="small"
          wrapperSize="big"
          className="-m-4"
        />
      )}
      {isVisible('move') && state.tasksIds.size > 0 && <Move />}
      {isVisible('archive') && state.unarchivedTasks.length > 0 && (
        <IconButton
          icon="IconArchive"
          color="secondary"
          onClick={store.archiveAll}
          size="small"
          wrapperSize="big"
          className="-m-4"
        />
      )}
      {isVisible('unarchive') && state.archivedTasks.length > 0 && (
        <IconButton
          icon="IconArchiveOff"
          color="secondary"
          onClick={store.unarchiveAll}
          size="small"
          wrapperSize="big"
          className="-m-4"
        />
      )}
      {isVisible('delete') && state.tasksIds.size > 0 && (
        <IconButton
          icon="IconTrash"
          onClick={store.deleteAll}
          color="secondary"
          size="small"
          wrapperSize="big"
          className="-m-4"
        />
      )}
      {isVisible('more') && state.tasksIds.size > 0 && <More />}
    </>
  )
})
